
const PageLoadingFallback = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA]">
      <div className="flex flex-col items-center gap-4">
        <div className="relative w-12 h-12">
          <div className="absolute inset-0 rounded-full border-[3px] border-[#E5E7EB]" />
          <div className="absolute inset-0 rounded-full border-[3px] border-transparent border-t-[#2D4A3E] animate-spin" />
        </div>
        <p className="text-sm text-gray-400 font-medium tracking-wide">Carregando...</p>
      </div>
    </div>
  );
};

export default PageLoadingFallback;
